import { INDRAApiService } from './api.indra.service';
import { URL_ROOT } from '@ibe.config';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
var PassengerPctcService = /** @class */ (function () {
    function PassengerPctcService(apiService) {
        this.apiService = apiService;
    }
    PassengerPctcService.prototype.saveEmergencyData = function (data, pnr, passenger_id) {
        var URL = URL_ROOT + "booking/pnrs/" + pnr + "/passengers/" + passenger_id + "/pctc/update";
        var _a = this.getNamesArray(data.emName), firstName = _a[0], lastName = _a[1];
        var emergencyRequest = {
            countryCode: data.emCountry,
            emergencyFlag: !data.declined,
            firstName: firstName,
            lastName: lastName,
            telephone: {
                countryCode: data.emPrefix,
                phoneNumber: data.emPhone
            }
        };
        return this.apiService.INDRA_put(URL, emergencyRequest);
    };
    PassengerPctcService.prototype.getNamesArray = function (name) {
        if (!_.isEmpty(name)) {
            var names = name.split(' ');
            if (Object.is(1, names.length)) {
                return [names[0], names[0]];
            }
            else {
                return [names[0], _.tail(names).join(' ')];
            }
        }
        return [null, null];
    };
    PassengerPctcService.ngInjectableDef = i0.defineInjectable({ factory: function PassengerPctcService_Factory() { return new PassengerPctcService(i0.inject(i1.INDRAApiService)); }, token: PassengerPctcService, providedIn: "root" });
    return PassengerPctcService;
}());
export { PassengerPctcService };
